import { authenticationTypes } from '../types'

const initialState = {
    loggedIn: false,
    loading: false,
    user: {},
    userType: null,
    tenantId: null,
    activeTenantId: null,
    activeTenantName: null,
    roles: [],
    permissions: [],
    error: null,
}

const extractUser = (action = {}) => {
    if (action.user && typeof action.user === "object") {
        return action.user
    }

    const {
        type,
        userType,
        tenantId,
        activeTenantId,
        activeTenantName,
        roles,
        permissions,
        loading,
        loggedIn,
        error,
        payload,
        ...rest
    } = action

    return rest
}

export function authentication(state = initialState, action) {
    switch (action.type) {
        case authenticationTypes.LOGIN_REQUEST: {
            return {
                ...state,
                loading: true,
                loggedIn: false,
                error: null,
            };
        }
        case authenticationTypes.LOGIN_SUCCESS: {
            const user = extractUser(action);
            return {
                loggedIn: true,
                loading: false,
                error: null,
                user,
                userType: action.userType || state.userType || null,
                tenantId: action.tenantId ?? state.tenantId ?? null,
                activeTenantId: action.activeTenantId ?? null,
                activeTenantName: action.activeTenantName ?? null,
                roles: action.roles || user.roles || [],
                permissions: action.permissions || user.permissions || [],
            };
        }
        case authenticationTypes.LOGIN_FAILURE: {
            return {
                ...initialState,
                loading: false,
                error: action.payload,
            };
        }
        case authenticationTypes.LOGOUT: {
            return {
                ...initialState,
                error: action.payload || null,
            }
        }
        case authenticationTypes.SET_AUTH_CONTEXT: {
            return {
                ...state,
                userType: action.userType ?? state.userType,
                tenantId: action.tenantId ?? state.tenantId,
                roles: action.roles || state.roles,
                permissions: action.permissions || state.permissions,
                user: action.user || state.user,
            }
        }
        case authenticationTypes.SET_ACTIVE_TENANT: {
            return {
                ...state,
                activeTenantId: action.activeTenantId || null,
                activeTenantName: action.activeTenantName || null,
            }
        }
        default:
            return state
    }
}
